import {Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit} from '@angular/core';

import {MenuService} from "@services/menu/menu.service";
import {AuthService} from "@services/auth/auth.service";
import {ApiService} from "@services/api.service";
import {HttpService} from "@services/http/http.service";
import {UserService} from "@services/user/user.service";
import {IonicModule} from "@ionic/angular";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
  standalone: true,
  imports: [IonicModule,CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SideMenuComponent implements OnInit {

  @Input('avatar') avatar: string = '';

  constructor(
    public menuService: MenuService,
    public auth: AuthService,
    public api: ApiService,
    public http: HttpService,
    public userProfile: UserService,
  ) {
  }

  ngOnInit() {
  }

  setMenuOffsetTop() {
    const header = document.querySelector('ion-header') as HTMLElement;
    const headerHeight = header.getBoundingClientRect().height.toFixed(2);
    const menu = document.querySelector('ion-menu') as HTMLElement;
    const menuOffset = menu.style.insetBlockStart;
    if (menuOffset != headerHeight + 'px') {
      menu.style.top = headerHeight + 'px';
    }
  }


}
